import { AxiosResponse } from 'axios'
import api from './Api'

export const createWellnessLectureListWithWellnessClass = (createWellnessLectureListWithWellnessClassRequest: ICreateWellnessLectureListWithWellnessClassRequest): Promise<AxiosResponse<boolean, any>> => {
    return api.post(`${process.env.REACT_APP_API_DOMAIN}/wellness-lecture/admin/list/v2`, createWellnessLectureListWithWellnessClassRequest)
}

export const getWellnessLectureListByDateRange = (startDate: string, endDate: string): Promise<AxiosResponse<Array<IWellnessLectureAdminResponse>, any>> => {
    return api.get(`${process.env.REACT_APP_API_DOMAIN}/wellness-lecture/admin/list/v2?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`)
}

export const getWellnessLectureDetailByWellnessLectureId = (wellnessLectureId: string): Promise<AxiosResponse<IWellnessLectureDetailAdminResponse, any>> => {
    return api.get(`${process.env.REACT_APP_API_DOMAIN}/wellness-lecture/admin/v2?wellnessLectureId=${wellnessLectureId}`)
}

export const deleteWellnessLectureByWellnessLectureId = (wellnessLectureId: string): Promise<AxiosResponse<boolean, any>> => {
    return api.delete(`${process.env.REACT_APP_API_DOMAIN}/wellness-lecture/admin/v2?wellnessLectureId=${wellnessLectureId}`)
}

export const updateReviveWellnessLectureByWellnessLectureId = (wellnessLectureId: string): Promise<AxiosResponse<boolean, any>> => {
    return api.put(`${process.env.REACT_APP_API_DOMAIN}/wellness-lecture/revive/admin/v2?wellnessLectureId=${wellnessLectureId}`)
}

export const updateAdminWellnessLecture = (updateWellnessLectureAdminRequest: IUpdateWellnessLectureAdminRequest): Promise<AxiosResponse<boolean, any>> => {
    return api.put(`${process.env.REACT_APP_API_DOMAIN}/wellness-lecture/admin/v2`, updateWellnessLectureAdminRequest)
}

export const getWellnessLectureLisForCheckInByYogaCenterId = (yogaCenterId: string, memberId: string): Promise<AxiosResponse<IYogaLectureListForCheckInResponse, any>> => {
    return api.get(`${process.env.REACT_APP_API_DOMAIN}/wellness-lecture/check-in?yogaCenterId=${yogaCenterId}&memberId=${memberId}`)
}